function BtnPrimary() {
  return (
    <div className="bg-gradient-to-r flex from-[#1bdfff] gap-[11px] items-center justify-center px-6 md:px-[34px] py-2 md:pb-[15px] md:pt-4 md:pr-7 rounded-[32px] to-[#6777ff] via-[#0098fb] via-[79.808%] w-full md:w-auto">
      <span className="font-semibold text-[15px] text-white tracking-[0.45px]">
        <a
          href={process.env.REACT_APP_XAODAO_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Join XAO DAO
        </a>
      </span>
      <img alt="arrow" className="w-4 h-4" src="./imageVector.png" />
    </div>
  );
}

export default function JoinXaoDao() {
  const assetsUrl = process.env.REACT_APP_ASSETS_URL;
  return (
    <section
      id="join"
      className="w-screen min-h-screen flex flex-col items-center justify-center py-8 md:py-12"
    >
      <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-center w-11/12 max-w-6xl mx-auto">
        <div className="flex-1 flex flex-col gap-4 items-center text-center md:items-start md:text-left justify-center px-4 md:px-12 order-1 md:order-1">
          <h2 className="font-medium text-3xl md:text-5xl text-[#121828] mb-2">
            Join XAO DAO
          </h2>
          <p className="text-base md:text-lg text-[#414653] mb-2">
            No personal information is required to join or to vote. However, if a
            member wishes to receive distributions of approved profits or grant
            funding, compliance with{" "}
            <span className="font-bold italic">KYC (Know Your Customer)</span>{" "}
            requirements and local jurisdictional laws will be mandatory at that
            stage. This ensures that the DAO remains{" "}
            <span className="font-bold italic">
              compliant, transparent and accountable.
            </span>
          </p>
          <p className="text-base md:text-lg text-[#414653] mb-2">
            By joining, members contribute to shaping the future direction of XAO
            DAO and the XRPL community at large.
          </p>
        </div>
        <div className="flex-1 flex items-center justify-center relative order-2 md:order-2">
          <img
            src="/aboutBg.png"
            alt="Background"
            className="absolute right-[-30px] bottom-[-30px] md:right-[-60px] md:bottom-[-60px] w-[200px] h-[200px] md:w-[340px] md:h-[340px] object-cover opacity-60 pointer-events-none z-0"
          />
          <div className="relative w-[300px] h-[240px] md:w-[520px] md:h-[392px] rounded-[14px] overflow-hidden shadow-lg bg-[#f7f8f9] flex items-center justify-center z-10">
            <img
              src="./joinxaodao.png"
              alt="Notifications"
              className="max-w-full max-h-full object-contain rounded-[14px]"
            />
            <div className="absolute inset-0 border-2 border-white rounded-[14px] pointer-events-none shadow-[0px_0px_34px_0px_rgba(18,24,40,0.07)]" />
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-4 justify-center w-11/12 max-w-[300px] md:max-w-6xl mx-auto mt-24 mb-10">
        <BtnPrimary />
        <button className="bg-white/5 border border-[#414653] rounded-[32px] px-6 md:px-8 py-2 md:py-4 text-[#414653] font-semibold text-sm md:text-[15px] tracking-wide w-full md:w-auto">
            <a
              href={`${assetsUrl}/help-video-1.mp4`}
              target="_blank"
              rel="noopener noreferrer"
            >
              How-To
            </a>
          </button>
        <button className="bg-white/5 border border-[#414653] rounded-[32px] px-6 md:px-8 py-2 md:py-4 text-[#414653] font-semibold text-sm md:text-[15px] tracking-wide w-full md:w-auto">
          <a
            href={process.env.REACT_APP_XAODAO_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Connect Wallet
          </a>
        </button>
      </div>
    </section>
  );
}